module.exports = __webpack_public_path__ + "static/Graphik-Regular-e2a1876e68b3885d03062214bc6016e9.otf";